// SignupForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AutoCompleteBox from '../../components/AutoCompleteBox';
import { useCommonDataContext } from '../../context/CommonDataProvider';



const SignupForm = () => {

  const { collegeData } =
  useCommonDataContext();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    // confirmPassword: '',
    phoneNumber:'',
    college_id:'',
    collegeName:'',
    role: '',
  });

    const navigate = useNavigate();

  const[ serverResponse, setServerResponse] = useState(''); // State to store server response if error

  const [error, setError] = useState('');

  const handleChange = (e) => {
  const { name, value } = e.target;

  // If the name is from AutoCompleteBox, you may need to handle it differently
  if (name === 'collegeName') {
      setFormData({
        ...formData,
        collegeName: value.collegeName,
        college_id: value.id
      });
  } else {
    setFormData({ ...formData, [name]: value });
  }

    // Clear the error message when the confirm password field is changed
    if (name === 'confirmPassword' || name === 'password') {
      if (formData.password === value || formData.confirmPassword === value) {
        setError(''); // Clear error if passwords are matching while typing
      }
    }
  };

  const handleSubmit = async (e) => {
    // console.log('data form signuo form',formData)
    e.preventDefault();

    if(formData.college_id === '' || formData.college_id === null || formData.college_id === undefined){
      setError('Please select a college from the list');
      return;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    if (formData.username.length < 4) {
      setError('UserName must be at least 4 characters long');
      return;
    }
    if (formData.phoneNumber.length != 10) {
      setError('Please give a valid Phone number');
      return;
    }

    // Check if passwords match
    // if (formData.password !== formData.confirmPassword) {
    //   setError('Passwords do not match');
    //   return;
    // }

    // Clear error if passwords match and proceed
    setError('');
    // console.log('Form Submitted', formData);
    // Add your form submit logic here
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/api/users/signup`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        // Handling different response statuses
        if (response.status === 400 || response.status === 500 || response.status === 401) {
          setServerResponse('Error signing up');
        //   setInvalid(true);
        }
        if(response.status === 422){
          setServerResponse('Email already exists');
        }
        if(response.status === 429){
          setServerResponse('Too many requests');
          alert('Too many requests try after some time');
        }

        if (response.ok) {
          const responseData = await response.json();
          // Assuming the response contains a token field
          const token = JSON.stringify(responseData);
          // const userDetails = responseData;
          
          navigate('/confirm-email');


          
          localStorage.setItem('token', token);
        } else {
          console.error('Error logging in:', response.statusText);
          // Handle error if needed
        }
      } catch (error) {
        console.error('Error logging in:', error);
        // Handle error if needed
      }
  };


  return (
    <div className=' px-6 py-2 rounded-b-2xl max-w-md mx-auto  flex flex-col justify-center items-center'>
    
      <form onSubmit={handleSubmit} className='space-y-3'>
        {/* Name Input */}
        <div>
          <label htmlFor="name" className='text-lg font-medium font-custom text-gray-700'>Name</label>
          <input
            id="username"
            name="username"
            type="text"
            value={formData.username}
            onChange={handleChange}
            className='w-full border-b border-blue-300 p-2 mt-1 bg-transparent font-custom '
            placeholder='Enter your name'
            required
          />
        </div>

        {/* Email Input */}
        <div>
          <label htmlFor="email" className='text-lg font-medium font-custom text-gray-700'>Email</label>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className='w-full border-b border-blue-300 p-2 mt-1 bg-transparent font-custom'
            placeholder='Enter your college email'
            required
          />
        </div>


        {/* Phone Input */}
        <div>
  <label htmlFor="phoneNumber" className="text-lg font-medium font-custom text-gray-700">
    Phone Number
  </label>
  <input
    id="phoneNumber"
    name="phoneNumber"
    type="text"
    value={formData.phoneNumber}
    onChange={(e) => {
      const input = e.target.value;
      // Allow only numbers and limit to 10 digits
      if (/^\d{0,10}$/.test(input)) {
        handleChange(e); // Only call handleChange if valid
      }
    }}
    className="w-full border-b border-blue-300 p-2 mt-1 bg-transparent font-custom"
    placeholder="Phone number"
    required
  />
</div>


        <div className=''>
          <label className='text-lg font-medium font-custom text-gray-700'>Select Your College</label>
        <AutoCompleteBox data={collegeData} handleChange={handleChange} name="collegeName"/>
        </div>
        {/* Password Input */}
        <div>
          <label htmlFor="password" className='text-lg font-medium font-custom text-gray-700'>Password</label>
          <input
            id="password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            className='w-full border-b border-blue-300 p-2 mt-1 bg-transparent font-custom'
            placeholder='Enter your password'
            required
          />
        </div>

        

        {/* Role Selection */}
        <div>
          <label htmlFor="role" className='text-lg font-medium font-custom text-gray-700'>Select Role</label>
          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            className='w-full border-b border-blue-300 p-2 mt-1 bg-transparent font-custom text-gray-500'
            required
          >
            <option value="" disabled>Select a role</option>
            <option value="STUDENT">STUDENT</option>
            <option value="ALUMNI">ALUMNI</option>
            <option value="STAFF">STAFF</option>
          </select>
        </div>

        {/* Error Message */}
        {error && <p className='text-center text-red-600 font-semibold mt-3'>{error}</p>}
        {serverResponse && <p className='text-center text-red-600 font-semibold mt-3'>{serverResponse}</p>}

        {/* Submit Button */}
        <div className='mt-6'>
          <button
            type="submit"
            className='w-full flex p-2 rounded-xl drop-shadow-lg font-custom items-center justify-center bg-skin-button text-white gap-2 active:scale-[0.98] active:duration-75 hover:scale-[1.01] ease-in-out transition-all'
          >
            Sign Up
          </button>
        </div>
      </form>
    </div>
  );
};

export default SignupForm;
